import { useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonTextAreaInput from "../../common/inputs/CommonTextAreaInput";
import sendEmailToCustomer from "../../../controllers/customer/sendEmailToCustomer";
import { enqueueSnackbar } from "notistack";

const CustomerDetailSendEmailModal = ({
  open,
  setOpen,
  data,
  reload,
  setLoading,
  loading,
}) => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const handleSend = async () => {
    if (!subject)
      return enqueueSnackbar("Subject is requred", { variant: "warning" });
    if (!body)
      return enqueueSnackbar("Body is requred", { variant: "warning" });
    const res = await sendEmailToCustomer({
      data: { to: data?.email, subject, body },
      setLoading,
    });
    if (res?.return) {
      enqueueSnackbar("Email has been sent successfully", {
        variant: "success",
      });
      setOpen(false);
      setSubject("");
      setBody("");
    } else {
      enqueueSnackbar("Something went wrong. Please try again!", {
        variant: "error",
      });
    }
  };

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        title="Send email"
        padding="p-6"
      >
        <div className="w-full flex flex-col gap-2">
          <CommonFreeTextInput
            label="Subject"
            value={subject}
            onChange={(val) => setSubject(val)}
          />
          <CommonTextAreaInput
            label="Body"
            value={body}
            onChange={(val) => setBody(val)}
          />
          <button
            className="w-full rounded-md h-12 flex items-center justify-center font-bold text-sm text-white bg-primary1 mt-2"
            onClick={() => handleSend()}
          >
            {loading ? <div className="buttonLoader"></div> : <>Send</>}
          </button>
        </div>
      </ModalContainer>
    </>
  );
};

export default CustomerDetailSendEmailModal;
